import { OnlineOnboardingDetails } from '@nemuru-eng/js-api-client';

import { PersonalInformationForm } from '@/components/modules/KYC/KYCOrder/components/PersonalInformation/components/PersonalInformationForm';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { PendingDataType } from '@/config/types';

export const PersonalInformation = ({
  onboardingDetails,
  loading,
}: {
  onboardingDetails?: OnlineOnboardingDetails;
  loading: boolean;
}) => {
  return (
    <SubSectionWrapper title={'PERSONAL_INFORMATION'}>
      {onboardingDetails ? (
        <>
          <PersonalInformationForm
            borrowerDetails={onboardingDetails}
            fieldVariant={FieldVariant.dataRow}
            loading={loading}
          />
        </>
      ) : (
        <PendingDataWarning type={PendingDataType.BORROWER_ONBOARDING} />
      )}
    </SubSectionWrapper>
  );
};
